import { Avatar, message } from "antd";
import React from "react";
import sx from "./Unfollow.module.scss";
import { useMutation } from "@tanstack/react-query";
import { unfollowBlogAPI, unfollowPhysicianAPI } from "../../api/GetBlogs";
import { queryClient } from "../../index";
import { useModalStore } from "../../store/ModalStore";
import CloseIcon from "../../assets/card_icons/CloseIcon";

const UnfollowModal = ({ myBlog, isBlog }) => {
  const { hideModal } = useModalStore();

  const { mutate: unfollowBlog } = useMutation({
    mutationFn: (blogId) => unfollowBlogAPI(blogId),
    onSuccess: () => {
      message.success("Unfollowed Blog Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetBlogfolio"] });
      queryClient.invalidateQueries({ queryKey: ["GetFollowedBlogs"] });
    },
  });

  const { mutate: unfollowDoctor } = useMutation({
    mutationFn: (userId) => unfollowPhysicianAPI(userId),
    onSuccess: () => {
      message.success("Unfollowed Physician Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetBlogfolio"] });
      queryClient.invalidateQueries({ queryKey: ["GetCurrentBlogFollowers"] });
    },
  });

  const handleUnfollow = () => {
    isBlog ? unfollowBlog(myBlog.id) : unfollowDoctor(myBlog.author.id);
    hideModal();
  };

  return (
    <div className={sx.modal}>
      <div className={sx.root}>
        <div className={sx.header}>
          <Avatar src={myBlog.author?.profileImage} size={70}>
            {myBlog.author?.firstName[0]}
            {myBlog.author?.lastName ? myBlog.author?.lastName[0] : ""}
          </Avatar>
          <p className={sx.name}>
            {myBlog.author?.firstName} {myBlog.author?.lastName ?? ""}
          </p>
          <div className={sx.mob_close} onClick={hideModal}>
            <CloseIcon />
          </div>
        </div>

        <div className={sx.content}>
          <p className={sx.title}>
            Are you sure you want to Unfollow this{" "}
            {isBlog ? "Blog" : "Physician"}?
          </p>

          <p className={sx.desc}>
            You are about to unfollow this {isBlog ? "Blog" : "Physician"}? This
            means you will no longer receive updates on their medical expertise
            and insights. Are you sure you want to unfollow?
          </p>

          <div className={sx.action}>
            <button className={sx.default} onClick={hideModal}>
              I've changed my mind
            </button>
            <button className={sx.primary} onClick={handleUnfollow}>
              Unfollow
            </button>
          </div>

          <div className={sx.web_close} onClick={hideModal}>
            <CloseIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
export default UnfollowModal;
